import { Link } from "react-router-dom";
import { ArrowRight, Check, Sparkles } from "lucide-react";
import { Browser, Phone, MOCKUPS, SalonPhone } from "@/components/site/SiteMockups";
import { HOME_TEXT as T } from "@/data/content";
import { WEB_PACKAGES } from "@/data/pricing";

const Showroom = MOCKUPS.showroom;
const Bar = MOCKUPS.bar;

const Visual = () => (
  <div className="relative mx-auto w-full max-w-[330px] pb-10 pt-4 sm:max-w-[600px]" aria-hidden="true">
    <Browser url="forma-interni.esempio.it" className="relative z-10"><Showroom /></Browser>
    <div className="absolute -left-4 -top-6 hidden w-[46%] rotate-[-4deg] opacity-90 sm:block"><Browser url="caffe-aurora.esempio.it"><Bar /></Browser></div>
    <Phone className="float-slow absolute -bottom-2 -right-2 z-20 w-[30%] min-w-[110px] sm:-right-6"><SalonPhone /></Phone>
    <div className="absolute -bottom-4 left-2 z-20 rounded-2xl border border-slate-200 bg-white/90 px-4 py-3 shadow-lg backdrop-blur-xl">
      {(() => { const p = WEB_PACKAGES.find((x) => x.featured) || WEB_PACKAGES[1]; return <>
        <p className="text-[10px] uppercase tracking-[0.2em] text-blue-700">{p.name} · {(p.badge || "consigliato").toLowerCase()}</p>
        <p className="font-display text-lg font-bold text-slate-900">{p.setup} <span className="text-sm font-medium text-slate-600">+ {p.monthly}</span></p>
      </>; })()}
    </div>
  </div>
);

export default function Hero() {
  return (
    <section className="bg-p-hero relative overflow-hidden text-slate-700">
      <div className="grid-bg pointer-events-none absolute inset-0 [mask-image:radial-gradient(ellipse_at_top,black,transparent_75%)]" />
      <div className="wrap relative grid items-center gap-12 pb-12 pt-8 sm:pt-14 lg:grid-cols-[1.05fr_1fr] lg:pb-20">
        <div>
          <Link to="/prezzi" data-testid="hero-entry-price" className="anim-in chip border-blue-200 bg-white/80 text-slate-800 transition-colors hover:border-blue-500">
            <Sparkles className="h-3.5 w-3.5 text-blue-600" /><span dangerouslySetInnerHTML={{ __html: T.hero_chip }} />
          </Link>
          <h1 data-testid="hero-title" className="anim-in d-1 mt-6 text-[2.6rem] font-extrabold leading-[0.98] text-[#0B1437] sm:text-6xl lg:text-7xl">
            {T.hero_title} <span className="hl-light">{T.hero_highlight}</span>
          </h1>
          <p className="anim-in d-2 mt-6 max-w-xl text-base leading-relaxed text-slate-700 md:text-lg">{T.hero_subtitle}</p>
          <div className="anim-in d-3 mt-8 flex flex-wrap gap-3">
            <a href="#portfolio" data-testid="hero-sites-btn" className="btn-primary">{T.hero_cta_primary} <ArrowRight className="h-4 w-4" /></a>
            <Link to="/prezzi" data-testid="hero-prices-btn" className="btn-glass">{T.hero_cta_secondary}</Link>
          </div>
          <ul className="anim-in d-4 mt-8 flex flex-wrap gap-x-6 gap-y-2 text-sm text-slate-700">
            {T.hero_bullets.filter(Boolean).map((t) => <li key={t} className="flex items-center gap-1.5"><Check className="h-4 w-4 text-blue-600" />{t}</li>)}
          </ul>
        </div>
        <div className="anim-in d-2">
          <Visual />
          <p className="mt-4 text-center text-[11px] text-slate-600">Anteprime di esempio con attività fittizie</p>
        </div>
      </div>
    </section>
  );
}
